import React from "react";
import { ModalType, useModal } from "../../../../Context/ModalContext";

function TextGeneratorButton(  ) {
  const { toggleShow } = useModal();

  return (
      <div className="toolbar-button"
           onClick={ () => {toggleShow(true, null, ModalType.textGenerator);} }
           data-test={"layout-text-generator"}>
        <i className="fa fa-wand-magic-sparkles"></i>
      </div>
      );
      }
      export default TextGeneratorButton;